import AES from 'crypto-js/aes'
import encUtf8 from 'crypto-js/enc-utf8'
import nav from '@/_nav'

const auth = {
  checkToken: () => {
    let isTokenExist = localStorage.accessToken ? true : false;
    return isTokenExist;
  },
  setToken: (hash) => {
    let normalizedToken = hash.replace(/ /g, '+');
    let decryptedBytes = AES.decrypt(normalizedToken, process.env.VUE_APP_PASSPHRASE);
    let token = decryptedBytes.toString(encUtf8);
    localStorage.accessToken = token;
  },
  setUser: (user) => {
    localStorage.user = JSON.stringify(user);
  },
  setRoles: (roles) => {
    localStorage.roles = JSON.stringify(roles)
  },
  setServiceModule: (service) => {
    localStorage.serviceModule = JSON.stringify(service)
  },
  getServiceModule: () => {
    return JSON.parse(localStorage.serviceModule)
  },
  getUser: () => {
    if (localStorage.user) {
      return JSON.parse(localStorage.user)
    } else {
      return {}
    }
  },
  getRoles: () => {
    return JSON.parse(localStorage.roles)
  },
  getNavs: () => {
    return nav
  },
  hasRole: (module, roleName) => {
    const moduleName = process.env.VUE_APP_MODE === 'production' ? module : module.toUpperCase()
    const role = roleName.toLowerCase()
    const services = JSON.parse(localStorage.serviceModule)
    const tmp = services.USER_MODULE
      .find((userModule) => userModule.MODULE_NAME === moduleName && userModule.USER_ROLE_NAME.toLowerCase() === role)
    return tmp ? true : false
  },
  getToken: () => {
    return localStorage.accessToken;
  },
  encryptToken: (token) => {
    let encryptedToken = AES.encrypt(token, process.env.VUE_APP_PASSPHRASE);
    return encryptedToken;
  },
  redirect: () => {
    let ssoUrl = process.env.VUE_APP_SSO_URL
    localStorage.clear()

    // ssoUrl = `${config.localSsoUrl}?appId=USSE-4` // uncomment for local development
    window.location.href = ssoUrl
  }
}

export default auth;
